export default __webpack_public_path__ + "static/media/2-nyc.959fdbf9.jpg";